<template>
  <div>
      <v-row>
        <v-col cols="12">
          <v-card flat v-if="value && value.length > 0">
            <v-card-text class="pa-0">
              <div class="d-flex flex-wrap">
                <download-file
                  v-for="(file, index) in paginatedFiles"
                  :key="file.fileGuid"
                  class="ma-5"
                  :width="250"
                  :iconWidth="50"
                  :showDeleteBtn="$store.state.userData.guid === ownerGuid"
                  @on-delete-complete="onDeleteAttachment(file)"
                  :item="file"
                  :preview="true"
                  :show-title="true"
                  :fileSizeFormat="file.fileSizeFormat"
                  :fileUrl="file.fileUrl"
                  thumbSuffixName="_thumb128.png"
                  :showNotSavedIcon="true"
                >
                </download-file>
              </div>

              <v-pagination
                v-model="currentPage"
                :length="totalPages"
                :total-visible="3"
                class="mx-auto my-5"
              />
            </v-card-text>
          </v-card>
          <NoData v-else />
        </v-col>
      </v-row>
  </div>
</template>

<script>
import DownloadFile from "../../../../components/downloadFile.vue";
import NoData from "../../../../components/noData.vue";
export default {
  name: "Attachments",
  components: {
    DownloadFile,
    NoData
  },
  data() {
    return {
      fileToDelete: null,
      currentPage: 1
    };
  },
  props: {
    ownerGuid: {
      type: String,
      required: true
    },
    sourceGuid: {
      type: String,
      required: true
    },
    sourceType: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      required: true
    },
    itemsPerPage: {
      type: Number,
      default: 10
    }
  },
  methods: {
    onDeleteAttachment(item) {
      this.$emit(
        "input",
        this.value.filter(m => m.fileUrl != item.fileUrl)
      );
    }
  },
  computed: {
    paginatedFiles() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.value.slice(start, start + this.itemsPerPage);
    },
    totalPages() {
      return Math.ceil(this.value.length / this.itemsPerPage);
    }
  }
};
</script>
